/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import {convertToItems} from '../../../common/utilities';
import InputList from '../../../components/general/input-list';
import {ts_translate} from "../../../common/clientTranslate";

const InputWrapper = styled.div`
	background: #fff;
	border-radius: 5px;

	& a {
		display: block;
		text-decoration: none;
		color: #43aaf1;
		// padding: 8px 18px 9px 11px;
	}

	& li.selected,
	& a {
		// font-size: 16px;
	}
`;

const ListWrapper = styled.div`
	position: absolute;
	z-index: 10;
	background: #fff;
	padding: 0 11px 0 27px;
	border-radius: 5px;
	width: 200px;

	& li {
		font-size: 14px;
		padding: 7px 0;
		border-color: #D5D6D7;
	}
`;

const List = styled.ul`
	flex: 0 1 ${({width}) => width ? width : '100%'};
	list-style: none outside;
	overflow: auto;
	${({isreport}) => isreport ? 'max-height: 250px;' : 'max-height: 400px;'}
`;

const ListItem = styled.li`
	font-size: 19px;
	color: ${({selected}) => selected ? '#43abf3' : '#3b3b3b'};
	padding-bottom: 15px;
	cursor: pointer;

	& + li {
		padding-top: 25px;;
		border-top: 1px solid #95989a;
	}
`;

class FilterSelect extends React.Component {
    constructor() {
        super();

        this.state = {
            expanded: null,
            current: {
                label: ts_translate('ERP-Nummer'),
                value:'erpnumber',
                selected: true,
            },
            filters: [{
                label: ts_translate('ERP-Nummer'),
                value:'erpnumber',
                selected: false,
            },{
                label: ts_translate('Order-Number'),
                value:'order_number',
                selected: false,
            },{
                label: ts_translate('Kunde'),
                value:'client',
                selected: false,
            },{
                label: ts_translate('Beschreibung'),
                value:'description',
                selected: false,
            },{
                label: ts_translate('Owner-Nr.'),
                value:'owningTaskErp',
                selected: false,
            },{
                label: ts_translate('Owner Decription'),
                value:'owningTaskDescription',
                selected: false,
            }]
        }
    }

    componentDidMount() {
        const {setFilter} = this.props;
        setFilter(this.state.current);
    }

    toggle() {
        const {expanded} = this.state;

        this.setState({expanded: !expanded})
    }

    handleSelect = (filter) => {
        const {setFilter} = this.props;
        this.toggle();
        this.setState({current: filter});
        setFilter(filter);
    };

    render() {
        const {expanded, current, filters} = this.state;

        return (
            <InputWrapper>
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.toggle();
                }}>{current.label}:</a>

                {expanded
                    ? (
                        <ListWrapper>

                            <List>
                                {filters.map((filter, index) => (
                                    <ListItem
                                        key={`list-item-${index}`}
                                        onClick={() => this.handleSelect(filter)}
                                        selected={filter.selected}
                                        className={`${filter.selected ? 'selected' : ''}`}
                                    >
                                        {filter.label}
                                    </ListItem>

                                ))}
                            </List>

                        </ListWrapper>
                    )
                    : <span></span>
                }
            </InputWrapper>
        );
    }
}

export default FilterSelect;



// WEBPACK FOOTER //
// ./src/components/dashboard/bar/filterselect.js